import React from 'react';
import CircularLoader from 'components/common/CircularLoader';
import { DEFAULT_PAGINATION_LIMIT } from 'api/constants';
import { formatData } from './PatientAdherenceRowCell/formatter';
import { getHeaderColumns } from './utils';
import VirtualizedComponent from './VirtualizedComponent';
import 'react-virtualized/styles.css';
import './styles.scss';
import TablePaginationControls from '../TablePaginationControls';

export interface IOwnProps {
  currentPage: number;
  patients: IFormattedPatientAdherenceDetails[];
  sortProp: Nullable<string>;
  sortOrder: SortOrderType;
  totalRecords: number;
  isTableShown: boolean;
  isTableLoading: boolean;
  hasFetchedIds: boolean;
  sortBy: (prop: string) => void;
  handlePageChange: (name: string) => void;
}

const PatientAdherenceTable = (props: IOwnProps) => {
  const {
    patients = [],
    sortBy,
    currentPage,
    sortOrder,
    sortProp,
    isTableShown,
    isTableLoading,
    hasFetchedIds,
    totalRecords,
    handlePageChange,
  } = props;

  const formattedPatients = formatData(patients);
  const headerColumn = getHeaderColumns();
  const isNoResult = isTableShown && !isTableLoading && patients.length === 0;
  const isDisabledControls = !hasFetchedIds || isTableLoading;

  return (
    <div styleName="wrapper" data-testid="adherence-table">
      <div data-testid={isTableLoading ? 'table-loading' : 'table-loaded'}>
        <div styleName="pagination-container">
          <TablePaginationControls
            isDisabledControls={isDisabledControls}
            dataTestId="adherence-pagination"
            count={totalRecords}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            rowsPerPage={parseInt(DEFAULT_PAGINATION_LIMIT, 10)}
          />
        </div>
        <VirtualizedComponent
          headerColumn={headerColumn}
          sortProp={sortProp}
          sortOrder={sortOrder}
          sortBy={sortBy}
          patients={isTableLoading ? [] : formattedPatients}
        />
      </div>
      {isTableLoading && <CircularLoader />}
      {isNoResult && <div styleName="no-result">No results found</div>}
    </div>
  );
};

export default PatientAdherenceTable;
